/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  camelcase,
  func-names,
  import/no-extraneous-dependencies,
  max-len,
  react/prop-types
*/
import React, { Component } from 'react';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Field } from 'common/components/forms';
import {
  actions, Errors, Control, Form,
} from 'react-redux-form';
import HfReactHelper from 'common/utils/hf-react-helper';
import { UIIcon } from 'dig-components/icons';
import { ShowLine, HideLine } from 'dig-components/dist/icons/src';
import { stringify } from 'qs';
import superagent from 'superagent';
import { connect } from 'react-redux';
import Button from 'common/components/button';
import GoogleSignInButton from './google-signin-button';
import DropboxSignInButton from './dropbox-signin-button';
import { loadArkoseCdnScript } from './arkose';
import './log-in-form.scss';

const FORM_NAME = 'logIn';
const errorLink = 'https://faq.hellosign.com/hc/en-us/articles/215578587-I-forgot-my-password-or-don-t-remember-creating-one ';

const messages = defineMessages({
  rememberMe: {
    id: '',
    defaultMessage: 'Remember me',
    description: 'remember me text on login page',
  },
  emailAddress: {
    id: '',
    defaultMessage: 'EMAIL ADDRESS',
    description: 'email address text on login page',
  },
  emailErrorMessage: {
    id: '',
    defaultMessage: 'Please enter a valid email address',
    description: 'email error message on login page',
  },
  forgotPassword: {
    id: '',
    defaultMessage: 'Forgot password?',
    description: 'forgot message on login page',
  },
  password: {
    id: '',
    defaultMessage: 'PASSWORD',
    description: 'password label on login page',
  },
  continue: {
    id: '',
    defaultMessage: 'CONTINUE',
    description: 'continue button on login page',
  },
  login: {
    id: '',
    defaultMessage: 'LOGIN',
    description: 'login button on login page',
  },
});

export class LogInForm extends Component {
    static propTypes = {
      // URL used to submit the form via POST
      submitUrl: PropTypes.string.isRequired,

      // Provided from Redux state by connect
      pending: PropTypes.bool.isRequired,

      // Redux dispatcher object, provided from Redux by connect
      dispatch: PropTypes.func.isRequired,

      // Needed by the GoogleSignInButton component
      googleSignInClientId: PropTypes.string.isRequired,

      // URL used to check if account is SAML enabled
      samlCheckUrl: PropTypes.string.isRequired,

      // Indicates SAML login
      samlLogin: PropTypes.bool,

      arkoseEnabled: PropTypes.bool,
      arkosePublicKey: PropTypes.string,

      intl: PropTypes.object,

      // Used to only display the HelloSign login option for the Microsoft Office Integration
      isOfficeAddIn: PropTypes.bool,

      isHubspot: PropTypes.bool,

      isHubspotv2: PropTypes.bool,

      isMobileApp: PropTypes.bool,
    };

    constructor(props) {
      super(props);

      this.state = {
        arkoseEnforcement: null,
        arkoseToken: null,
        arkoseEnabled: this.props.arkoseEnabled,
        formValues: null,
        email: this.props.emailAddress ? this.props.emailAddress : '',
        password: '',
        usernamePasswordError: false,
        hidePassword: true,
        showPasswordToggleIcon: false,
      };

      this.handleGeneralError = this.handleGeneralError.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleResponse = this.handleResponse.bind(this);
      this.handleContinue = this.handleContinue.bind(this);
      this.handleSamlVerificationResponse = this.handleSamlVerificationResponse.bind(this);
      this.handleEditEmailAddress = this.handleEditEmailAddress.bind(this);
    }

    /**
     * Handles any generic/fallback errors we want to handle
     */
    handleGeneralError() {
      this.props.dispatch(actions.setSubmitFailed(FORM_NAME));
    }

    handleResponse(err, response) {
      // Error here means some kind of network error (4xx or 5xx)
      if (err) {
        return this.handleGeneralError(err);
      }

      try {
        // display errors if necessary
        const resp = response.body;

        // Create notification if backend provided one
        if (resp.notification) {
          hellofaxJS.createNotification({
            text: resp.notification.message,
            class_name: resp.notification.type,
          });
        }

        // Handle success
        if (resp.success === true) {
          this.props.dispatch(actions.setSubmitted(FORM_NAME));

          // Redirect to on_login_redirect_url
          if (resp.on_login_redirect_url) {
            window.location = resp.on_login_redirect_url;
            Cookie.clear('deferred_login_redirect_url'); // Clear cookie since we don't need to defer the redirect
          }
        } else {
          // Handle failure
          this.props.dispatch(actions.setSubmitFailed(FORM_NAME));

          const hasErrorMsg = !!(resp.error && resp.error.message);

          if (resp.on_error_redirect_url) {
            // Redirect to on_error_redirect_url
            window.location = resp.on_error_redirect_url;
          } else if (hasErrorMsg && !resp.notification_message) {

            // If this is Arkose failure we need to retest the user
            if (resp.error.code === 'Z') {
              // Clean up the token we had in the state
              this.setState({ arkoseToken: null });
              // Is we received an arkose response, rollout was enabled
              // in the middle of the session so let's load the test
              if (!this.state.arkoseEnforcement) {
                this.setState({ arkoseEnabled: true });
                this.loadArkose();
              } else {
                // Rerun the test
                this.state.arkoseEnforcement.run();
              }
            }

            if (resp.error.code === 'A') {
              // Conditional error to embed errorLink,
              // setErrors does not accept JSX.Element
              this.setState({ usernamePasswordError: true });
            } else {
              this.setState({ usernamePasswordError: false });
              // Display error message
              this.props.dispatch(
                actions.setErrors(FORM_NAME, {
                  server: resp.error.message,
                }),
              );
            }
          }
        }

        if (response.error) {
          this.props.dispatch(
            actions.setErrors(FORM_NAME, {
              server: resp.error.message,
            }),
          );
        }
      } catch (e) {
        return this.handleGeneralError(err);
      }
    }

    handleSamlVerificationResponse(err, response) {
      try {
        const resp = response.body;
        if (resp.saml === true) {
          // Redirect the user to the SAML login
          window.location = resp.login_url;
        } else if (resp.error) {
          this.props.dispatch(
            actions.setErrors(FORM_NAME, {
              server: resp.error,
            }),
          );
        } else {
          // Open the organic login flow
          // Disable Arkose only for QA automation (DEV-12296)
          if (resp.disable_arkose) {
            this.setState({
              arkoseEnabled: false,
            });
          }
          this.props.dispatch(actions.setInitial(FORM_NAME));
          this.props.dispatch(actions.change(`${FORM_NAME}.samlLogin`, false));
        }
      } catch (e) {
        return this.handleGeneralError(err);
      }
    }

    handleSubmit(values) {
      if (this.props.samlLogin !== false) {
        // Navigate the execution to the Continue click since user clicked ENTER key from the email field
        return this.handleContinue();
      }

      // Set those in the state if we need to use them after a test
      this.setState({ formValues: values });

      if (this.isArkoseEnabled() && !this.state.arkoseToken) {
        // Save the form values in the state so we can use them after verification
        return this.state.arkoseEnforcement.run();
      }

      const data = stringify({
        login: {
          email_address: values.emailAddress,
          password: values.password,
          should_remember_me: values.rememberMe,
          _csrf_token: values.csrfToken,
          pending_tsm_group_guid: values.pendingTsmGroupGuid,
          redirect_url: values.redirectUrl,
        },
        async: 1,
        arkose_token: this.state.arkoseToken,
      });

      return superagent
        .post(this.props.submitUrl)
        .type('form')
        .send(data)
        .on('request', () => {
          this.props.dispatch(actions.setPending(FORM_NAME));
        })
        .end(this.handleResponse);
    }

    handleContinue() {
      const data = stringify({
        account: this.props.emailAddress,
        csrfToken: this.props.csrfToken,
        redirect_url: this.props.redirectUrl,
      });

      return superagent
        .post(this.props.samlCheckUrl)
        .type('form')
        .send(data)
        .on('request', () => {
          this.props.dispatch(actions.setPending(FORM_NAME));
        })
        .end(this.handleSamlVerificationResponse);
    }

    handleEditEmailAddress() {
      this.props.dispatch(actions.change(`${FORM_NAME}.samlLogin`, null));
      this.setState({ usernamePasswordError: false });
    }

    handleArkoseEnforcementCompleted(response) {
      this.setState({ arkoseToken: response.token });
      // Go back and submit the form
      this.handleSubmit(this.state.formValues);
    }

    isArkoseEnabled() {
      return this.state.arkoseEnabled === true;
    }

    loadArkose() {
      loadArkoseCdnScript(this.props.arkosePublicKey, (enforcement) => {
        enforcement.setConfig({
          data: {},
          // language: 'en', // TODO: Translate
          onCompleted: (response) => {
            this.handleArkoseEnforcementCompleted(response);
          },
          onHide: () => {},
          onReady: () => {},
          onReset: () => {},
          onShow: () => {},
          onShown: () => {},
          onSuppress: () => {},
        });
        // Add the enforcement to the state so we can use it later
        this.setState({ arkoseEnforcement: enforcement });
      });
    }

    componentDidMount() {
      if (this.isArkoseEnabled()) {
        this.loadArkose();
      }
    }

    displayPasswordVisibilityIcon = () => {
      this.setState({
        showPasswordToggleIcon: true,
      });
    };

    blurPasswordVisibilityIcon = () => {
      this.setState({
        showPasswordToggleIcon: false,
      });
    };

    render() {
      const {
        pending,
      } = this.props;

      // Map site codes to site names
      const textVersions = {
        S: 'HelloSign',
        F: 'HelloFax',
        W: 'HelloWorks',
      };

      const emailInputField = <Control.input
        type="email"
        model="logIn.emailAddress"
        value={this.state.email}
        onChange={(event) => this.setState({ email: event.target.value })}
        autoFocus={!!(this.props.samlLogin === null && this.props.emailAddress)}
        onFocus={function (e) { const val = e.target.value; e.target.value = ''; e.target.value = val; }}
        data-heap-redact-text='true'
        data-qa-ref="email_login_input"
        validators={{
          isEmail: HfReactHelper.isValidEmailAddress,
        }} />;

      const emailStaticField = <div>
        <span className="m-email-static-field">{this.props.emailAddress}</span>
        <span className="m-edit-icon" onClick={this.handleEditEmailAddress}></span>
      </div>;

      // Determine which email block to use based on the state
      let emailField = emailInputField;
      let emailLabel = this.props.intl.formatMessage(messages.emailAddress);
      if (this.props.samlLogin === false && this.props.emailAddress) {
        emailField = emailStaticField;
        emailLabel = '';
      }
      const changePasswordType = () => {
        this.setState((preState) => ({
          ...preState,
          hidePassword: !preState.hidePassword,
        }));
      };

      // Invisible in the first step when we determine if the user is SAML
      const passwordField = this.props.samlLogin === false
            && <Field label={this.props.intl.formatMessage(messages.password)}>
              <div className='password-control'>
                <Control.input
                  className='password'
                  type={this.state.hidePassword ? 'password' : 'text'}
                  value={this.state.password}
                  onChange={(event) => this.setState({ password: event.target.value })}
                  autoFocus={!!(this.props.samlLogin === false && this.props.emailAddress)}
                  onKeyDown={this.handleKeyDown}
                  data-heap-redact-text='true'
                  onClick={this.displayPasswordVisibilityIcon}
                  onBlur={this.blurPasswordVisibilityIcon}
                  model="logIn.password" />
                {this.state.showPasswordToggleIcon
                && <div
                  className={`input-group-append ${this.state.showPasswordToggleIcon ? 'input-group-append-background--gray-color' : 'input-group-append-background--white-color'}`}
                >
                  <div className="input-group-text">
                    <UIIcon
                      id='password-visibility'
                      className='password-visibility'
                      src={this.state.hidePassword ? HideLine : ShowLine}
                      onMouseDown={(evt) => evt.preventDefault()}
                      onClick={changePasswordType} />
                  </div>
                </div>
                }
              </div>
              <a
                className="m-log-in-form--forgot-password-link"
                href="/account/recoverPassword"
                onClick={() => {
                  // Save email field value to sessionStorage for prefill on the next page
                  // (Only if emailAddress is not null, since sessionStorage casts that to "null")
                  if (this.props.emailAddress) {
                    window.sessionStorage.email = this.props.emailAddress;
                  }
                  return true;
                }}
              >
                {this.props.intl.formatMessage(messages.forgotPassword)}
              </a>
            </Field>;

      const loginBtn = this.props.samlLogin === false
            && <div className={`m-log-in-form--submit columns ${!this.props.isHubspot ? 'small-6' : ''}`}>
              <Button
                buttonText={this.props.intl.formatMessage(messages.login)}
                buttonColor="azure"
                type="submit"
                disabled={pending}
                data-heap-redact-text='true'
                buttonAttrs={
                    {
                      'da-category': 'login',
                      'da-action': textVersions[this.props.siteCode],
                    }
                  } />
            </div>;

      const continueBtn = this.props.samlLogin !== false
            && <div className={`m-log-in-form--continue columns ${!this.props.isHubspot ? 'small-6' : ''}`}>
              <Button
                buttonText={this.props.intl.formatMessage(messages.continue)}
                buttonColor="azure"
                onClick={this.handleContinue}
                disabled={pending}
                data-heap-redact-text='true'
                buttonAttrs={
                      {
                        'data-qa-ref': 'continue-button-login-page',
                        'da-category': 'login',
                        'da-action': textVersions[this.props.siteCode],
                        'da-label': 'sign in',
                      }
                  } />
            </div>;

      const formControlBtn = this.props.samlLogin === false ? loginBtn : continueBtn;

      const rememberMe = (!this.props.isHubspot)
          && <div className="m-log-in-form--remember-me small-6 columns">
            <label>
              <Control.checkbox model="logIn.rememberMe" data-qa-ref="remember_me_checkbox" />{' '}
              {this.props.intl.formatMessage(messages.rememberMe)}
            </label>
          </div>;

      const submitControls = <div className="m-log-in-form--submit-controls row">
        {rememberMe}
        {formControlBtn}
      </div>;

      const googleSignIn = (!this.props.isOfficeAddIn && !this.props.isMobileApp)
        && <GoogleSignInButton
          clientId={this.props.googleSignInClientId}
          redirectUrl={this.props.redirectUrl}
          csrfToken={this.props.csrfToken}
          buttonAttrs={
            {
              'da-category': 'login',
              'da-action': textVersions[this.props.siteCode],
              'da-label': 'sign in google',
            }
          } />;

      const dropboxSignIn = (!this.props.isOfficeAddIn && !this.props.isMobileApp)
          && <div className="l-margin-t-20">
            <DropboxSignInButton
              redirectUrl={this.props.redirectUrl}
              buttonAttrs={{
                'da-category': 'login',
                'da-action': textVersions[this.props.siteCode],
                'da-label': 'sign in dbx',
              }} />
          </div>;

      return (
        <div className="m-log-in-form">
          {googleSignIn}
          {dropboxSignIn}
          <hr className={`l-margin-v-40 ${this.props.isHubspotv2 ? 'm-invisible' : ''}`} />
          <Form model={FORM_NAME} onSubmit={this.handleSubmit} data-heap-redact-text='true'>
            <Field label={emailLabel}>
              {emailField}
              <Errors
                model="logIn.emailAddress"
                show="touched"
                messages={{
                  isEmail: this.props.intl.formatMessage(messages.emailErrorMessage),
                }}
                className="m-field--error" />
            </Field>

            {passwordField}

            <div className="l-margin-v-20">
              {this.state.usernamePasswordError
                && <p data-qa-ref="invalid-login-message" className='m-invalid-login'>
                  <FormattedMessage
                    id=''
                    description='error message for incorrect username and password combination at login'
                    defaultMessage='Invalid username and/or password. <a>Learn more</a>.'
                    values={{
                      /* eslint-disable-next-line react/display-name */
                      a: (...chunks) => <a href={errorLink} target="_blank" rel="noopener noreferrer">{chunks}</a>,
                    }} />
                </p>
              }
              {!this.state.usernamePasswordError
                && <Errors
                  model={FORM_NAME}
                  show={true}
                  className="c-blood"
                  component={(props) => <span data-qa-ref="invalid-login-message">{props.children}</span>} />
              }
            </div>

            {submitControls}

          </Form>
        </div>
      );
    }
}

function mapStateToProps(state) {
  const { $form } = state.forms.logIn;

  return {
    pending: $form.pending,
    emailAddress: state.logIn.emailAddress,
    csrfToken: state.logIn.csrfToken,
    redirectUrl: state.logIn.redirectUrl,
    samlLogin: state.logIn.samlLogin,
  };
}

export default injectIntl(connect(mapStateToProps)(LogInForm));
